<template>
    <div class="thread-not-found">
        <h1>Oops! That thread doesn't exist.</h1>
        <router-link :to="linkToForum">
            Back to the forum
        </router-link>
    </div>
</template>

<script>
    // ForumThreadNotFound: a 404 page for threads.

    export default {
        computed: {
            linkToForum() {
                return {
                    name: 'forum-home',
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    h1 {
        font-size: 39px;
        margin: 0 0 30px;
    }

    a {
        color: #33ccff;
    }
</style>



// WEBPACK FOOTER //
// thread-not-found.vue?ac65ca12